export default __webpack_public_path__ + "static/media/wind-solid.b90c8e83.svg";